import { number, object, string } from 'yup';
import { RegionCode, RemainingEntitlement, TotalEntitlement, } from '../UserDataManagement';
import { getFormValues } from './validationContextTools';
const RequiredMessage = 'This field is required.';
const MaxMessage = 'You cannot input more than 365 days of entitlement for one year';
const EntitlementMinMessage = 'You cannot input entitlement of less than half a day';
const RemainingEntitlementMinMessage = 'You cannot input entitlement of less 0';
let RemainingError = '';
function validateRemainingEntitlement(totalEntitlement, remainingEntitlementFormValue, userSettingsState, newEndDate) {
    const remainingEntitlementMaxValue = totalEntitlement - userSettingsState.daysBookedUsingAbdoo;
    const missingEntitlementDays = remainingEntitlementFormValue - remainingEntitlementMaxValue;
    if ((userSettingsState.initialSetupDone &&
        newEndDate.toISOString() === userSettingsState.end.toISOString() &&
        remainingEntitlementFormValue > remainingEntitlementMaxValue) ||
        (!userSettingsState.initialSetupDone &&
            remainingEntitlementFormValue > remainingEntitlementMaxValue)) {
        RemainingError = `To add ${missingEntitlementDays} day(s) to your Remaining Entitlement, increase your Total by at least the same amount`;
        return false;
    }
    return true;
}
export const introEntitlementFormSchemaFunc = (userSettingsState, newEndDate) => object({
    [TotalEntitlement]: number()
        .nullable()
        .required(RequiredMessage)
        .min(0.5, EntitlementMinMessage)
        .max(365, MaxMessage),
    [RemainingEntitlement]: number()
        .nullable()
        .required(RequiredMessage)
        .min(0, RemainingEntitlementMinMessage)
        .test('max', () => RemainingError, (value, context) => {
        const totalEntitlement = getFormValues(context).totalEntitlement ?? 0;
        return validateRemainingEntitlement(totalEntitlement, value, userSettingsState, newEndDate);
    }),
    [RegionCode]: string(),
});
